import preferences from "@coworker/enums/profilePreferences";
import { useGroupByFilter } from "./useGroupByFilter";
import { useSortByFilter } from "./useSortByFilter";
import { FilterValue } from "../../shared/filters/types/filter";
import { useHfbSelectFilter } from "./useHfbSelectFilter";
import { useUserPreferenceStoreFilterValues } from "../../shared/filters/utils/store/useUserPreferenceStoreFilterValues";

export function useMultiOrderAddonsFilters() {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.MULTI_ORDER_ADDONS_FILTERS
  );

  const useMultiOrderAddonsDataFilters = (values: FilterValue[]) => [
    useHfbSelectFilter("articleHFBString"),
    useSortByFilter(values),
    useGroupByFilter(),
  ];

  return {
    useFiltersFactory: useMultiOrderAddonsDataFilters,
    filterValues,
    setFilterValues,
  };
}
